/* eslint-disable react-hooks/exhaustive-deps */
import useMyInfo from '@api/hooks/auth/useMyInfo';
import { getIsLoggedIn } from '@api/selectors/auth';
import useFetch from '@hooks/useFetch';

const useSubjectAndLanguages = (
  goalUID,
  options = { fallbackData: undefined }
) => {
  const isLoggedIn = useMyInfo(getIsLoggedIn);
  const key = `v2/doubts/learner/filter/?goal_uid=${goalUID}&filter=SUBJECT,LANGUAGE,STATE`;
  const {
    data: subjectAndLanguageData,
    mutate,
    ...rest
  } = useFetch(
    isLoggedIn ? key : null,
    {},
    { fallbackData: options.fallbackData }
  );

  return {
    key,
    subjectAndLanguageData: subjectAndLanguageData || {},
    mutate,
    ...rest
  };
};

export default useSubjectAndLanguages;
